import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, LinearProgress, Stack } from '@mui/material';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';

import useNotification from '../../../../../core/hooks/use_notification';
import AutomaticExpirationPromotionSettingList from './automatic_expiration_promotion_setting_list';
import { getExpirationPromotionSettingAction, getExpirationPromotionSettingState } from '../../../../../features/price/get_expiration_promotion_setting';
import { getExpirationPromotionSettingNotificationData, updateExpirationPromotionSettingNotificationData } from '../../../../../core/utils/notification_utils';
import { SubmitButton } from '../../../../common/button';
import RadioGroupFormik from '../../../../common/radio_group';
import { yesNoOptions } from '../../../../common/form_utils';
import { updateExpirationPromotionSettingAction, updateExpirationPromotionSettingState } from '../../../../../features/price/update_expiration_promotion_setting';
import SectionPaper from '../../../../common/section_paper';

const SettingForm = ({ tab }) => {
    const { showErrorMessage, showNotification } = useNotification();
    const dispatch = useDispatch();

    const refreshExpirationPromotionSetting = useCallback(() => {
        dispatch(getExpirationPromotionSettingAction())
            .then(response => showErrorMessage(getExpirationPromotionSettingNotificationData(response)));
    }, [dispatch, showErrorMessage]);

    const getExpirationPromotionSettings = useSelector(getExpirationPromotionSettingState);
    const updateExpirationPromotionSettings = useSelector(updateExpirationPromotionSettingState);

    useEffect(() => {
        refreshExpirationPromotionSetting();
    }, [refreshExpirationPromotionSetting]);

    const initialValues = {
        notificationEnabled: getExpirationPromotionSettings?.data?.notificationEnabled || false,
    }

    const schema = Yup.object().shape({
        notificationEnabled: Yup.bool().required()
    });

    const onSubmit = (values) => {
        const form = { ...values };

        dispatch(updateExpirationPromotionSettingAction({ form }))
            .then(response => showNotification(updateExpirationPromotionSettingNotificationData(response)))
    };

    return (
        <Stack spacing={ 4 } sx={ { width: '100%', pb: 4 } }>
            <SectionPaper title="Ustawienia ogólne">
                { getExpirationPromotionSettings?.loading && <LinearProgress/> }
                {
                    getExpirationPromotionSettings?.data &&
                    <Formik
                        initialValues={ initialValues }
                        validationSchema={ schema }
                        validateOnChange={ false }
                        validateOnBlur={ false }
                        onSubmit={ onSubmit }>
                        { () => (
                            <Box component={ Form } sx={ { display: 'flex', flexDirection: 'column' } }>
                                <Box sx={ { mt: 1 } }>
                                    <RadioGroupFormik
                                        name="notificationEnabled"
                                        label="Wysyłaj notyfikacje o promocjach na krótki termin przydatności"
                                        options={ yesNoOptions }
                                    />
                                </Box>

                                <Box sx={ {
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    mt: 3,
                                    pt: 2,
                                    borderTop: theme => `1px solid ${ theme.palette.divider }`
                                } }>
                                    <SubmitButton isLoading={ updateExpirationPromotionSettings?.loading }>
                                        Zapisz ustawienia
                                    </SubmitButton>
                                </Box>
                            </Box>
                        ) }
                    </Formik>
                }
            </SectionPaper>

            <SectionPaper title="Automatyczne promocje">
                <Box sx={ { mt: 2 } }>
                    <AutomaticExpirationPromotionSettingList tab={ tab }/>
                </Box>
            </SectionPaper>
        </Stack>
    );
};

export default SettingForm;